import axios from "axios";

import { APIGW_ROOT, LANDING_URL } from './api';

const APIGW_ROOT_USER = `${APIGW_ROOT}users`


export default class UserModel {

  constructor() {
  }

  // Create new user
  signup(email, password) {
    return new Promise(async (ok, reject) => {
      let payload = { email, password }

      try {
        const res = await axios.post(`${APIGW_ROOT_USER}/signup`, payload)
        if (res.status !== 200) {
          reject(res.statusText)
        }
        ok(res)
      } catch (e) {
        ErrorHandler(reject, e)
      }
    })
  }

  // Authenticating
  signin(email, password) {
    return new Promise(async (ok, reject) => {
      let payload = { email,password }

      try {
        const res = await axios.post(`${APIGW_ROOT_USER}/signin`, payload)
        if (res.status !== 200) {
          reject(res.statusText)
        }
        //console.log("Sign in: ", res)
        ok(res)
      } catch (e) {
        ErrorHandler(reject, e)
      }
    })
  }

  /**
   * activate
   *
   * Activate user
   *
   * @param s {string} t parameter from url path
   * @param code {string} what user had inter
   * @returns {Promise<unknown>}
   */
  activate(s, c) {
    return new Promise((async (ok, reject) => {
      let [ uuid, token, name ] = s.split("___")

      let code = c.split("").filter(i => i.match(/\d+/i)).join("")

      try {
        const res = await axios.post(`${APIGW_ROOT_USER}/activate`, { uuid,token,code,name })
        if (res.status === 200) {
          ok(res)
        }
      } catch (e) {
        ErrorHandler(reject, e)
      }
    }))
  }

  resetPass(token, payload) {
    return new Promise((async (ok, reject) => {
      try {
        const res = await axios.post(`${APIGW_ROOT_USER}/reset/${token}`, payload)
        if (res.status === 200) {
          ok(res)
        }
      } catch (e) {
        reject(e.response.data)
      }
    }))
  }


  refreshToken(token) {
    return new Promise(async (ok, reject) => {
      let payload = { token }

      try {
        const res = await axios.post(`${APIGW_ROOT_USER}/refresh`, payload)
        if (res.status !== 200) {
          reject(res.statusText)
        }
        //console.log("Sign in: ", res)
        ok(res)
      } catch (e) {
        ErrorHandler(reject, e)
      }
    })
  }

  // createNewUserWP(email, username, password) {
  //   return new Promise( async (resolve, reject) => {
  //     const payload = { email, password, username };
  //     try {
  //       const res = await axios.post(
  //         `${LANDING_URL}wp-json/wp/v2/users`,
  //         JSON.stringify(payload),
  //         {
  //           headers: {
  //             "Authorization": "Basic ZGV2ZWxvcDoqOU0mbTAzbw==",
  //             "Content-Type": "application/json",
  //           }
  //         }
  //       );
  //       if (res.status !== 200) {
  //         reject(res.statusText);
  //       }
  //       resolve(res);
  //     } catch (error) {
  //       ErrorHandler(reject, error);
  //     }
  //   })
  // }
}



// Error handler 
const ErrorHandler = (r, e) => {
  //console.log(e)
  //console.log(e.response ? e.response.status : '')

  // Logic for readable error messages depending on status code
  let errorMessage = '';

  if (e.response) {
    switch(e.response.status) {
      case 400:
        errorMessage = 'Invalid request, please try again later'
        break;
      case 401:
        errorMessage = 'Invalid user or/and password'
        break;
      case 422:
        errorMessage = 'Invalid input: please, check if email and password are correct'
        break;
      case 500:
        errorMessage = 'An error occured, please try again later'
        break;
      default: 
        break;
    }
  }

  if (e.response && typeof(e.response.data) === "object" && "error" in e.response.data) {
    console.log(Error(e.response.data.error))
    r(Error(e.response.data.error))
  }

  if (e.response && typeof(e.response.data) === "string") {
    console.log(Error(e.response.data))
    r(Error(e.response.data))
  }

  // If the status code matches one of the cases and is not empty, 
  /// return custom
  // error message; otherwise return e
  r(errorMessage ? errorMessage : e)
}
